




















import { Component, Prop } from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanyDocument } from '@/store/models';
import DocumentSharing from '@/components/DocumentSharing.vue';
import DocumentPresentation from '@/components/DocumentPresentation.vue';

@Component({
    components: {DocumentPresentation, DocumentSharing},
})
export default class MetaCompetitors extends CompanyMixin {
    @Prop() readonly doc!: CompanyDocument;
}
